import { cn } from '@/core/ui';
import { Cards } from '@/core/ui/icons';
import { BLOCKS, CATEGORIES } from '../../domain/blocks';
import type { BlockType } from '../../domain/types';
import { BlockGlyph } from '../BlockGlyph';
import { CATEGORY_TONE } from '../icons';
import { CARD_DRAG, DRAG_MIME } from './context';

interface Props {
  /** Clique: o bloco entra no card selecionado (ou num card novo). */
  onAdd: (type: BlockType) => void;
  onAddCard: () => void;
  /** Há card selecionado para receber o bloco? (só muda a dica) */
  hasTarget: boolean;
}

/** A paleta: card novo e os blocos por família. Arrastar para o canvas ou clicar. */
export function Palette({ onAdd, onAddCard, hasTarget }: Props) {
  return (
    <nav aria-label="Blocos" className="flex h-full flex-col gap-4 overflow-y-auto p-3">
      <button
        type="button"
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData(DRAG_MIME, CARD_DRAG);
          e.dataTransfer.effectAllowed = 'copy';
        }}
        onClick={onAddCard}
        className="flex items-center gap-2.5 rounded-2xl bg-brand-400 px-3 py-2.5 text-sm font-medium text-on-brand transition-colors hover:bg-brand-500"
      >
        <Cards aria-hidden className="size-4" />
        Card
      </button>
      <p className="-mt-2 px-1 text-[11px] text-fg-subtle">
        {hasTarget
          ? 'Clique para pôr no card selecionado ou arraste.'
          : 'Arraste para o canvas ou para um card.'}
      </p>

      {CATEGORIES.map((cat) => (
        <section key={cat.id}>
          <h3 className="mb-1.5 px-1 text-[10px] font-semibold tracking-widest text-gray-400 uppercase">
            {cat.label}
          </h3>
          <ul className="space-y-1">
            {BLOCKS.filter((b) => b.category === cat.id).map((b) => {
              return (
                <li key={b.type}>
                  <button
                    type="button"
                    draggable
                    title={b.hint}
                    onDragStart={(e) => {
                      e.dataTransfer.setData(DRAG_MIME, b.type);
                      e.dataTransfer.effectAllowed = 'copy';
                    }}
                    onClick={() => onAdd(b.type)}
                    className="flex w-full cursor-grab items-center gap-2 rounded-xl bg-surface-2 px-2 py-1.5 text-left text-sm text-fg-muted transition-colors hover:bg-gray-100 hover:text-fg active:cursor-grabbing"
                  >
                    <span
                      className={cn(
                        'flex size-6 shrink-0 items-center justify-center rounded-lg',
                        CATEGORY_TONE[b.category],
                      )}
                    >
                      <BlockGlyph type={b.type} className="size-3.5" />
                    </span>
                    <span className="truncate">{b.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </nav>
  );
}
